"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importStar(require("styled-components"));
var uuid_1 = __importDefault(require("uuid"));
var _1 = require(".");
var TitleBar = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-content: center;\n\tflex-grow: 0;\n\tflex-shrink: 0;\n\n\t", "\n"], ["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-content: center;\n\tflex-grow: 0;\n\tflex-shrink: 0;\n\n\t", "\n"])), function (props) { return props.theme.messageDialog.titleBar; });
var DialogHeader = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), function (props) { return props.theme.messageDialog.title; });
var MsgDialog = styled_components_1.default(_1.Dialog)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: relative;\n\t", "\n"], ["\n\tposition: relative;\n\t", "\n"])), function (props) { return props.theme.messageDialog.dialog; });
var CloseButton = styled_components_1.default.button(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\ttext-align: center;\n\tbackground: transparent;\n\tborder: none;\n\t", "\n"], ["\n\ttext-align: center;\n\tbackground: transparent;\n\tborder: none;\n\t", "\n"])), function (props) { return props.theme.messageDialog.closeButton; });
var Content = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tflex-grow: 1;\n\tflex-shrink: 1;\n\tposition: relative;\n\n\t", "\n"], ["\n\tflex-grow: 1;\n\tflex-shrink: 1;\n\tposition: relative;\n\n\t", "\n"])), function (props) { return props.theme.messageDialog.content; });
var MessageDialog = /** @class */ (function (_super) {
    __extends(MessageDialog, _super);
    function MessageDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.titleId = "msgdialog-" + uuid_1.default.v4();
        return _this;
    }
    MessageDialog.prototype.render = function () {
        // need to define different closing buttons here
        var close = undefined;
        if (!this.props.onClose || !this.props.hideClose) {
            close = (react_1.default.createElement(CloseButton, { onClick: this.props.onClose, "aria-label": this.props.closeTooltip, "data-automationid": "close-dialog", altTheme: this.props.altTheme }, this.props.altTheme ? this.props.theme.svgs.close_filled : this.props.theme.svgs.icon_dialog_close));
        }
        return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: this.props.altTheme ? this.props.theme.themes.alt : this.props.theme.themes.main },
            react_1.default.createElement(MsgDialog, { className: this.props.className, title: { id: this.titleId }, onClose: this.props.onClose, descriptionId: this.props.descriptionId, id: this.props.id },
                react_1.default.createElement(TitleBar, null,
                    react_1.default.createElement(DialogHeader, { id: this.titleId },
                        this.props.title,
                        close)),
                react_1.default.createElement(Content, null,
                    react_1.default.createElement(react_1.default.Fragment, null, this.props.children)))));
    };
    MessageDialog.propTypes = {
        title: prop_types_1.default.string.isRequired,
        closeTooltip: prop_types_1.default.string.isRequired,
        onClose: prop_types_1.default.func.isRequired,
        children: prop_types_1.default.node.isRequired,
        /** id to give the root of the dialog instead of a generated one  */
        id: prop_types_1.default.string,
        /** id of the element containing the primary message */
        descriptionId: prop_types_1.default.string,
        /** swap the colours for this dialog */
        altTheme: prop_types_1.default.bool,
        hideClose: prop_types_1.default.bool
    };
    MessageDialog.defaultProps = {
        title: '',
        closeTooltip: '',
        onClose: function () { },
        children: '',
    };
    return MessageDialog;
}(react_1.Component));
exports.default = styled_components_1.withTheme(MessageDialog);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=MessageDialog.js.map